export var BTN_TEXT_MORE_VARIANTS = 'еще варианты';
export var STEP_FOR_SLICE = 5;
export var ICON_TYPE_MORE_VARIANTS = /*#__PURE__*/function (ICON_TYPE_MORE_VARIANTS) {
  ICON_TYPE_MORE_VARIANTS["More"] = "more";
  ICON_TYPE_MORE_VARIANTS["ArrowRight"] = "arrow-right";
  return ICON_TYPE_MORE_VARIANTS;
}({});